import React from 'react';
import AddIcon from '@material-ui/icons/Add';
import strings from 'strings';
import { FPIconButton, When } from 'UI/components/atoms';
import Searchbar from 'UI/components/molecules/Searchbar';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';

import { TemplateCard, TemplateCardSkeleton } from '../TemplateCard';

import { useMessageTemplates } from './DrawerTemplates.hooks';
import { SearchbarContainer } from './DrawerTemplates.styled';

const COPIES = strings.messageCenter.messageComposer.templates;

export const DrawerTemplates = ({ open, onSelectTemplate, toggleTemplates }) => {
  const showUseTemplateButton = Boolean(onSelectTemplate);
  const {
    handleClickNewTemplate,
    handleSearchAsync,
    handleSearchChange,
    handleSelectTemplate,
    removeTemplate,
    searchKeyword,
    showSearchBar,
    showSkeleton,
    templates,
    updateTemplates
  } = useMessageTemplates({ onSelectTemplate });

  const isEmpty = templates.length === 0;

  return (
    <FPDrawer
      CardHeaderProps={{ title: COPIES.title }}
      FPDrawerProps={{ 'aria-label': 'drawer templates', open }}
      onClose={toggleTemplates}
      additionalHeaderButton={
        <FPIconButton
          onClick={handleClickNewTemplate}
          icon={AddIcon}
          tooltipProps={{ title: COPIES.new }}
        />
      }
    >
      <When condition={showSearchBar}>
        <SearchbarContainer>
          <Searchbar
            name="searchKeyword"
            onChange={handleSearchChange}
            onSearchAsync={handleSearchAsync}
            placeholder={COPIES.search}
            showClearButton
            value={searchKeyword}
            width="auto"
          />
        </SearchbarContainer>
      </When>

      {showSkeleton ? (
        <TemplateCardSkeleton />
      ) : (
        <>
          {templates.map(({ id, title, template }, index) => (
            <TemplateCard
              key={id || title}
              id={id}
              index={index}
              onClickUseTemplate={handleSelectTemplate}
              removeTemplate={removeTemplate}
              showUseTemplateButton={showUseTemplateButton}
              template={template}
              title={title}
              updateTemplates={updateTemplates}
            />
          ))}

          <When condition={isEmpty}>
            <EmptyPlaceholder subtitle={COPIES.empty} />
          </When>
        </>
      )}
    </FPDrawer>
  );
};
